import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";
import { ToastContainer, toast } from "react-toastify";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ImageModal from "components/ImageModal";
import EmptyData from "components/EmptyData";
import { useSelector } from "react-redux";
import apiClient from "../../Utils/apiClient";
import socketService from "../../socket/newsocketService";

function Wellbeing_Managment() {
  const navigate = useNavigate();
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");
  const [openWellBeingMod, setWellBeingMod] = useState(false);
  const [modData, setModData] = useState(null);
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleImageClick = useCallback((url) => {
    if (!url) {
      return;
    }

    setIsModalOpen(true);
    setOnClickImageData(url);
  }, []);

  const closeDetailModal = useCallback(() => {
    setWellBeingMod(false);
    setModData(null);
  }, []);

  const columns = useMemo(
    () => [
      { Header: <span style={{ color: "blue" }}>SR</span>, accessor: "sr", align: "center" },
      {
        Header: (
          <span className="text-danger h6" style={{ fontWeight: "bolder" }}>
            Image
          </span>
        ),
        accessor: "userImage",
        align: "center",
      },
      { Header: <span style={{ color: "blue" }}>Name</span>, accessor: "name", align: "center" },
      { Header: <span style={{ color: "blue" }}>Email</span>, accessor: "email", align: "center" },
      { Header: <span style={{ color: "blue" }}>Phone</span>, accessor: "phone", align: "center" },
      { Header: <span style={{ color: "blue" }}>Origin</span>, accessor: "origin", align: "center" },
      { Header: <span style={{ color: "blue" }}>State</span>, accessor: "state", align: "center" },
      {
        Header: <span style={{ color: "blue" }}>Destination</span>,
        accessor: "dest",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Transport Mode</span>,
        accessor: "transMode",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Partner Type</span>,
        accessor: "partner",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Partner Name</span>,
        accessor: "partnerName",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Partner Contact</span>,
        accessor: "partnerCont",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Arrival Date</span>,
        accessor: "date",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Arrival Time</span>,
        accessor: "time",
        align: "center",
      },
      {
        Header: <span style={{ color: "blue" }}>Vehicle Number</span>,
        accessor: "vehicleNumber",
        align: "center",
      },
      { Header: <span style={{ color: "blue" }}>Status</span>, accessor: "status", align: "center" },
      { Header: <span style={{ color: "blue" }}>View</span>, accessor: "Action", align: "center" },
      { Header: <span style={{ color: "blue" }}>Map</span>, accessor: "Location", align: "center" },
    ],
    []
  );

  const getWellBeingServices = useCallback(async () => {
    const currentAdminData = JSON.parse(localStorage.getItem("user") || "{}");
    const getAdminState = currentAdminData?.state || "";
    const userAdmin = Boolean(currentAdminData?.superAdmin);

    setCheckSuperAdmin(userAdmin);
    setAdminState(getAdminState);
    setLoading(true);

    try {
      const selectedState =
        getUserState === "" || getUserState === "All State" ? "" : getUserState;
      const stateFilter = userAdmin ? selectedState : getAdminState;
      const pageSize = 200;
      let page = 1;
      let totalPages = 1;
      const allRecords = [];

      do {
        const params = { page, limit: pageSize };
        if (stateFilter) {
          params.state = stateFilter;
        }

        const response = await apiClient.get("/virtual-travel-guard", {
          params: {
            ...params,
            includeHomeCheck: true,
          },
        });
        const pageRecords = Array.isArray(response?.data) ? response.data : [];
        allRecords.push(...pageRecords);
        totalPages = Number(response?.pagination?.totalPages || 1);
        page += 1;
      } while (page <= totalPages);

      const mappedRows = allRecords.map((record, index) => {
        const payload = record?.payload || {};
        const userId = record?.userId || payload?.userId || "";
        const imageUrl = payload?.WellBeingTripPic || record?.userImage || "";
        const destination = Array.isArray(payload?.destLocTxt)
          ? payload.destLocTxt.join(", ")
          : payload?.destLocTxt || payload?.destLoc || payload?.ArrivalStation || "---";

        return {
          sr: index + 1,
          sourceType: record?.sourceType || payload?.sourceType || "virtualtravelguard",
          userImage: imageUrl ? (
            <img
              onClick={() => handleImageClick(imageUrl)}
              src={imageUrl}
              alt={record?.userName || payload?.Name || "user"}
              style={{ width: 50, height: 50, borderRadius: "50%", cursor: "pointer" }}
            />
          ) : (
            "N/A"
          ),
          name: record?.userName || payload?.userName || payload?.Name || "Unknown User",
          email: record?.userEmail || payload?.userEmail || "N/A",
          phone: record?.userPhone || payload?.userPhone || payload?.PhoneNumber || "N/A",
          origin: payload?.currentLocTxt || payload?.currentLoc || payload?.Place || "---",
          state: record?.state || payload?.state || "N/A",
          dest: destination,
          transMode:
            payload?.TransportType ||
            payload?.transportMode ||
            (payload?.ArrivalStation ? "Train" : "Own Transport"),
          partner: payload?.PartenerType || payload?.PartnerType || payload?.PartnerRelation || "N/A",
          partnerName: payload?.Name || payload?.PartnerName || "N/A",
          partnerCont: payload?.PhoneNumber || payload?.PartnerMobileNo || record?.userPhone || "N/A",
          date: payload?.ArrivalDate || payload?.TripDate || "N/A",
          time: payload?.ArrivalTime || payload?.TripTime || "N/A",
          vehicleNumber: payload?.VehicleNumber || "N/A",
          status: payload?.Trip_Status || record?.status || "Completed",
          Action: (
            <Button
              onClick={() => {
                setModData(record);
                setWellBeingMod(true);
              }}
              style={{ padding: 4, backgroundColor: "#f2f2f2" }}
            >
              <VisibilityIcon />
            </Button>
          ),
          Location: (
            <Button
              onClick={() => {
                if (userId) {
                  navigate(`/locate/${userId}?userData=truck`);
                }
              }}
              variant="outlined"
              size="small"
            >
              Track
            </Button>
          ),
        };
      });

      setRows(mappedRows);
    } catch (error) {
      console.error("[Wellbeing_Managment] failed to load VTG history", error);
      toast.error(error?.message || "Failed to load Virtual Travel Guard history");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [getUserState, handleImageClick, navigate]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
      return;
    }

    getWellBeingServices();
  }, [getWellBeingServices, navigate]);

  useEffect(() => {
    const handleRefresh = () => {
      getWellBeingServices();
    };

    socketService.on("virtualtravelguard", handleRefresh);
    socketService.on("wellbeingescort", handleRefresh);

    return () => {
      socketService.off("virtualtravelguard", handleRefresh);
      socketService.off("wellbeingescort", handleRefresh);
    };
  }, [getWellBeingServices]);

  const filteredRows = useMemo(() => {
    const search = searchTerm.toLowerCase().trim();

    return rows.filter((row) =>
      [
        row.name,
        row.email,
        row.phone,
        row.origin,
        row.dest,
        row.partnerName,
        row.partnerCont,
      ]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(search)),
    );
  }, [rows, searchTerm]);

  const detailData = modData?.payload || modData || {};
  const detailDestination = Array.isArray(detailData?.destLocTxt)
    ? detailData.destLocTxt.join(", ")
    : detailData?.destLocTxt || detailData?.destLoc || detailData?.ArrivalStation || "N/A";
  const detailImage = detailData?.WellBeingTripPic || modData?.userImage || "";

  return (
    <DashboardLayout>
      <ToastContainer />
      <MDBox pt={6} pb={3}>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={5} px={2}>
          <TextField
            label="Search by name, email and phone"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
          />
        </Box>

        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    {checkSuperAdmin
                      ? getUserState === "" || getUserState === "All State"
                        ? "All States "
                        : `${getUserState} State `
                      : `${adminState} State `}
                    Virtual Travel Guard History
                  </MDTypography>
                </MDBox>

                <MDBox pt={3}>
                  {filteredRows.length > 0 ? (
                    <DataTable
                      table={{ columns, rows: filteredRows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  ) : (
                    <EmptyData />
                  )}
                </MDBox>
              </Card>

              <ImageModal
                onClickImageData={onClickImageData}
                onClose={() => setIsModalOpen(false)}
                isModalOpen={isModalOpen}
              />

              <Modal
                open={openWellBeingMod}
                style={{ borderRadius: 5 }}
                onClose={closeDetailModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  className="col-md-9 col-sm-9 col-lg-6 pb-4"
                  style={{
                    backgroundColor: "white",
                    borderRadius: 20,
                    alignSelf: "center",
                    marginTop: "10%",
                    marginLeft: "auto",
                    marginRight: "auto",
                    minHeight: 400,
                  }}
                >
                  <div className="row">
                    <div className="col-5 ms-4 mt-4">
                      <p style={{ fontSize: 14 }}>
                        WellBeingCheck Type: Virtual Travel Guard <br />
                        Name: {detailData?.userName || detailData?.Name || "N/A"}
                        <br />
                        {detailData?.currentLocTxt || detailData?.currentLoc || detailData?.Place
                          ? ` Current Location: ${
                              detailData?.currentLocTxt ||
                              detailData?.currentLoc ||
                              detailData?.Place
                            }`
                          : null}
                        {detailDestination ? ` Destination: ${detailDestination}` : null}
                        <br />
                        Transport Mode:{" "}
                        {detailData?.TransportType ||
                          detailData?.transportMode ||
                          (detailData?.ArrivalStation ? "Train" : "Own Transport")}
                        <br />
                        Source: {modData?.sourceType || detailData?.sourceType || "virtualtravelguard"}
                        <br />
                        Date: {detailData?.ArrivalDate || detailData?.TripDate || "N/A"}
                        <br />
                        Time: {detailData?.ArrivalTime || detailData?.TripTime || "N/A"}
                        <br />
                        Partner Type: {detailData?.PartenerType || detailData?.PartnerType || "N/A"}
                        <br />
                        Partner Name: {detailData?.Name || detailData?.PartnerName || "N/A"}
                        <br />
                        Partner Phone Number:{" "}
                        {detailData?.PhoneNumber ||
                          detailData?.PartnerMobileNo ||
                          modData?.userPhone ||
                          "N/A"}
                        <br />
                        Vehicle Number: {detailData?.VehicleNumber || "N/A"}
                      </p>
                    </div>

                    <div className="col mt-5 ms-4">
                      {detailImage ? (
                        <img
                          src={detailImage}
                          style={{ backgroundSize: "cover", borderRadius: 10 }}
                          alt="user"
                          height={250}
                          width={300}
                        />
                      ) : null}
                    </div>
                  </div>
                </Box>
              </Modal>
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Wellbeing_Managment;
